import { AdsTargeting, getGPTAdsTargeting } from '@apis/partnerSuccess';

import { useAxiosQuery, UseAxiosQueryOptions } from '@hooks/useAxiosQuery';

interface UseTargetingParams {
  pageName: 'FLIGHT_SEARCH_RESULT';
  searchId: string;
  wegoAnalyticsClientId: string;
}

export const useAdditionalGPTTargeting = (
  { pageName, searchId, wegoAnalyticsClientId }: UseTargetingParams,
  options?: UseAxiosQueryOptions<AdsTargeting>,
) => {
  return useAxiosQuery({
    queryKey: ['gpt-ads-targeting', { pageName, searchId, wegoAnalyticsClientId }],
    queryFn: () => getGPTAdsTargeting(pageName, searchId, wegoAnalyticsClientId),
    initialData: undefined, // Prevent calling GPT/GAM Ad request before API call is completed
    staleTime: Infinity, // Prevent refetching
    retry: false, // Disable retries since we want to use fallback data immediately
    ...options,
  });
};
